<script lang="ts">
  import type { ApiField } from '../../data-tables-api';
  import Icon from '../../../components/Icon.svelte';
  import FieldDisplay from '../FieldDisplay.svelte';

  let {
    field,
    value,
    onChange: _onChange,
    error: _error,
    disabled: _disabled = false,
  }: {
    field: ApiField;
    value: unknown;
    onChange: (v: unknown) => void;
    error?: string | null;
    disabled?: boolean;
  } = $props();
</script>

<!--
  Universal stub editor для readonly-полів (is_computed, formula, stat).
  Просто рендерить значення через FieldDisplay у muted-стилі — admin не може редагувати.
-->
<div class="flex items-center gap-2 rounded-md border border-dashed border-[var(--color-border-3)] bg-[var(--color-bg-3)] px-3 py-2 text-sm text-[var(--color-text-muted)]">
  <Icon name="refresh" size={12} />
  <FieldDisplay {field} {value} />
  {#if field.is_computed && field.computation?.description}
    <span class="ml-auto truncate text-[10px] italic">
      {field.computation.description}
    </span>
  {/if}
</div>
